import request from "@/plugins/axios/request";

export function apiSearch(keyWord) {
    return request({
        url: "/apidoc/search",
        method: "get",
        params: {
            keyWord
        }
    });
}
export function apiType() {
    return request({
        url: "/apidoc/api/category",
        method: "get"
    });
}
export function apiTypesh(id) {
    return request({
        url: "/apidoc/api/category/" + id,
        method: "get"
    });
}

export function apiNavDetails() {
    return request({
        url: "/apidoc/api/categoryAll",
        method: "get"
    });
}

export function apiDetails(apiId) {
    return request({
        url: `/apidoc/${apiId}`,
        // url: "/api/doc?id=" + apiId,
        method: "get"
    });
}

export function myApplication(appInfo) {
    return request({
        url: "/page/app/search",
        method: "post",
        data: appInfo
    });
}

export function addApplication(appInfo) {
    return request({
        url: "/page/app/save",
        method: "post",
        data: appInfo
    });
}

export function apiByApp(appInfo) {
    return request({
        url: "/page/api/byApp",
        method: "post",
        data: appInfo
    });
}

export function addapi(accObject) {
    return request({
        url: "/page/api/save",
        method: "post",
        data: accObject
    });
}

export function querykey(appId) {
    return request({
        url: `/page/app/get/${appId}`,
        method: "get"
    });
}

export function updateCallBackInfo(updateInfo) {
    return request({
        url: "/page/app/update/callbackUrl",
        method: "put",
        data: updateInfo
    });
}
export function getSelect(id) {
    return request({
        url: "/page/" + id,
        method: "get"
    });
}

export function myApplications(id, appInfo) {
    return request({
        url: "/" + id,
        method: "post",
        data: appInfo
    });
}

export function requestPhone(phone) {
    return request({
        url: `/page/mobileVaildCode/${phone}`,
        method: "get"
    });
}

export function requestSecretkey(params) {
    return request({
        url: "/page/app/get/secretkey",
        method: "post",
        data: params
    });
}

export function deleteApiByAppId(ids) {
    return request({
        url: "/page/api/nexus",
        method: "post",
        data: ids
    });
}

export function updateApiStatus(updateInfo) {
    return request({
        url: "/page/api/online",
        method: "put",
        data: updateInfo
    });
}

export function updateAppInfo(updateApp) {
    return request({
        url: "page/app/update/baseInfo",
        method: "put",
        data: updateApp
    });
}

export function updateAppInfoFor(updateApp) {
    return request({
        url: "page/app/update/baseInfoFor",
        method: "put",
        data: updateApp
    });
}

export function passWordmodify(updateApp) {
    return request({
        url: "white/platuser/forgetPassword",
        method: "post",
        data: updateApp
    });
}

// 签名方式
export function signature() {
    return request({
        url: "/apidoc/digest ",
        method: "get"
    });
}

// 错误码
export function errorCode() {
    return request({
        url: "/apidoc/error/code",
        method: "get"
    });
}

export function menuqueryaddressid(appInfo) {
    return request({
        url: "/osmenucateory/menuqueryaddressid",
        method: "post",
        data: appInfo
    });
}

export function queryarticlebyid(appInfo) {
    return request({
        url: "/articlecontroller/queryarticlebyid",
        method: "post",
        data: appInfo
    });
}

export function companyhistoryyear(appInfo) {
    return request({
        url: "/aboutcompany/companyhistoryyear",
        method: "post",
        data: appInfo
    });
}
export function companyhonor(appInfo) {
    return request({
        url: "/aboutcompany/companyhonor",
        method: "post",
        data: appInfo
    });
}

export function selecthistorybyyear(appInfo) {
    return request({
        url: "aboutcompany/selecthistorybyyear",
        method: "post",
        data: appInfo
    });
}

export function findCompanyCount(appInfo) {
    return request({
        url: "sysDict/findcominstro",
        method: "post",
        data: appInfo
    });
}

export function selectcompanydev(appInfo) {
    return request({
        url: "/aboutcompany/selectcompanydev",
        method: "post",
        data: appInfo
    });
}

export function menuquerybyid(appInfo) {
    return request({
        url: "/osmenucateory/menuquerybyid",
        method: "post",
        data: appInfo
    });

}
export function findbytype(appInfo) {
    return request({
        url: "/sysDict/getbytype",
        method: "get",
        params: appInfo
    });

}
